import { gql } from '@/__generated__';
import { type StandardAutocompleteDataQuery } from '@/__generated__/graphql';

export type StandardAutocompleteIrrigation = NonNullable<
  StandardAutocompleteDataQuery['irrigations']
>[number];
export type StandardAutocompleteDevice = NonNullable<
  StandardAutocompleteDataQuery['devices']
>[number];
export type StandardAutocompleteOrganization = NonNullable<
  StandardAutocompleteDataQuery['organizations']
>[number];

const STANDARD_AUTOCOMPLETE_DATA = gql(`#graphql
  query StandardAutocompleteData(
    $includeDevices: Boolean!
    $includeOrganizations: Boolean!
    $includeIrrigations: Boolean!
    $includeUsers: Boolean!
    $includeProjects: Boolean!
    $includeCurrencies: Boolean!
    $includeServiceTypes: Boolean!
    $includeAnnouncements: Boolean!
    $includeIntegrations: Boolean!

    $devicesInput: DevicesInput
    $organizationsInput: OrganizationsInput
    $usersInput: UsersFilter
    $projectsFilter: ProjectsFilter
    $announcementsInput: AnnouncementsFilter
  ) {
    devices(input: $devicesInput) @include(if: $includeDevices) {
      id
      profile {
        id
        name
      }
    }
    organizations(input: $organizationsInput) @include(if: $includeOrganizations) {
      id
      name
    }
    irrigations @include(if: $includeIrrigations) {
      id
      name
    }
    users(filter: $usersInput) @include(if: $includeUsers) {
      id
      name
      lastnames
    }
    projectsPagination(filter: $projectsFilter) @include(if: $includeProjects) {
      items {
        id
        projectId
      }
    }
    currencies @include(if: $includeCurrencies) {
      id
      name
    }
    serviceTypes @include(if: $includeServiceTypes) {
      id
      name
    }
    announcementsPagination(filter: $announcementsInput, pagination: { limit: 10000 }) @include(if: $includeAnnouncements) {
      items {
        id
        title
      }
    }
    integrations @include(if: $includeIntegrations) {
      id
      name
    }
  }
`);

export default STANDARD_AUTOCOMPLETE_DATA;
